module.exports = "<div>\n  <pre>{{ settings | json }}</pre>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/settings-debug/settings-debug.component.html
// module id = ./src/app/shared/settings-debug/settings-debug.component.html
// module chunks = main